import React, { FC, useCallback, useEffect, useMemo } from "react";
import { Dropdown, IconToggle, IconToggleText, IJSXOption } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { CategoryBlock, IconToggleFitContent } from "../TopBar/styled";
import { SharedButtonContainer } from "../../styled";

import { ResourceCategory } from "../../hooks/useFetchParams";
import { getCategory } from "../../../../ducks/catalog/selectors";
import { setCategory } from "../../../../ducks/catalog/catalog";
import { useFilter } from "../../hooks/useFilter";
import { CategoryBlockCollapsed, CategoryBlockExpanded } from "./styled";

export const CategoryFilter: FC = () => {
  const { t } = useTranslation("catalog");
  const [category, updateCategory] = useFilter(getCategory, setCategory);

  const setUserCategory = useCallback(() => updateCategory(ResourceCategory.User), [updateCategory]);

  const setSharedCategory = useCallback(() => {
    updateCategory(ResourceCategory.Shared);
  }, [updateCategory]);

  const setPublicCategory = useCallback(() => {
    updateCategory(ResourceCategory.Public);
  }, [updateCategory]);

  useEffect(() => {
    window.localStorage.getItem("category") === "shared" && setSharedCategory();

    return () => {
      window.localStorage.getItem("category") === "shared" && localStorage.removeItem("category");
    };
  }, []); // eslint-disable-line

  const options: IJSXOption[] = useMemo(
    () => [
      {
        value: ResourceCategory.User,
        text: t("myResources"),
      },
      {
        value: ResourceCategory.Shared,
        text: t("sharedResources"),
      },
      {
        value: ResourceCategory.Public,
        text: t("publicResources"),
      },
    ],
    [t],
  );

  return (
    <>
      <CategoryBlockExpanded>
        <CategoryBlock>
          <IconToggle isSelected={category === ResourceCategory.User} onClick={setUserCategory}>
            <IconToggleText>{t("myResources")}</IconToggleText>
          </IconToggle>
          <SharedButtonContainer>
            <IconToggleFitContent isSelected={category === ResourceCategory.Shared} onClick={setSharedCategory}>
              <IconToggleText>{t("sharedResources")}</IconToggleText>
            </IconToggleFitContent>
            <IconToggleFitContent isSelected={category === ResourceCategory.Public} onClick={setPublicCategory}>
              <IconToggleText>{t("publicResources")}</IconToggleText>
            </IconToggleFitContent>
            {/* PUB-3241: Временно (?) выпиливем счетчик новых ресурсов
             */}
            {/* !!newResourcesCount && <Chip text={`+${newResourcesCount}`} secondary />
             */}
          </SharedButtonContainer>
        </CategoryBlock>
      </CategoryBlockExpanded>
      <CategoryBlockCollapsed>
        <Dropdown
          width="12.5rem"
          zIndex={120}
          options={options}
          placeholder={t("allSourceTypes")}
          value={category}
          onChange={categories => {
            updateCategory(categories[0].value as ResourceCategory);
          }}
        />
      </CategoryBlockCollapsed>
    </>
  );
};
